import { useEffect, useState } from 'react'
import './style.css'
import { Accordion, Alert, Button, Card, Col, Container, Row, Stack } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom';
// import { MdAdd } from "react-icons/md";
import { FaRobot, FaPlus } from "react-icons/fa";
import CreateAgent from './CreateAgent';
import { useAgentContext } from '../../context/agent';
import { useOrgContext } from '../../context/org';
import PaymentPlan from '../Organization/Subscription';

function Agents() {
    const {agents} = useAgentContext();
    const [createAgent, setCreateAgent] = useState(false);
    // const defaultImage = "/images/chat-icon.svg";

    const {getOrgById, setOrg, membership, subscription} = useOrgContext();
    const {orgId} = useParams();
    const org = getOrgById(orgId || "");

    const isAllowed = ["owner", "admin", "editor"].includes(membership?.role || "");

    // let permission = !allowed.includes(membership?.role || "");
    // if(org && org.agentsLeft <= 0) permission = true;
    

    useEffect(()=>{
        setOrg(org);
    }, [org, setOrg]);

    return (
        <div style={{ color: "#ffffff", minHeight: "100vh" }}>
        {!subscription ? <PaymentPlan/> : ( 
        <>
            {/* Header */}
            <div style={{ backgroundColor: "#2d2d2d", borderBottom: "1px solid #444" }} className="sticky-top">
                <Container fluid className="py-3">
                    <Row className="align-items-center">
                        <Col>
                            <div className="d-flex align-items-center">
                                <div className="bg-primary rounded p-2 me-3">
                                    <FaRobot className="text-white" />
                                </div>
                                <div>
                                    <h4 className="mb-0 text-light">AI Agents</h4>
                                    <small style={{ color: "#999" }}>
                                        {agents?.length || 0} agents created
                                    </small>
                                </div>
                            </div>
                        </Col>
                        <Col xs="auto">
                            <Button 
                                disabled={!isAllowed || (org && org.agentsLeft <= 0)}
                                variant="primary"
                                size="sm"
                                onClick={() => setCreateAgent(true)}
                            >
                                <FaPlus className="me-2" />
                                Add Agent
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container fluid className="py-4" style={{maxWidth:1200, margin:"0 auto"}}>
                {createAgent && <CreateAgent show={createAgent} setShow={setCreateAgent} />}
            {org && org.agentsLeft <= 0 ? (
                <Alert variant="info">
                    You have reached the maximum number of Agents allowed for this organization. <Link to={`plans`}>Upgrade your subscription</Link> to add more agents/chatbots.
                </Alert>
                ): 
                !subscription && (
                <Alert variant="info">
                    You are not subscribed to any plan for this organization. <Link to={`plans`}>Choose a plan</Link> to get started.
                </Alert>
            )}

            <Row className="mb-4">
                <Col xs={12}>
                    <Accordion defaultActiveKey={null} className="org-usage-accordion">
                        <Accordion.Item eventKey="0" style={{ backgroundColor: "#232323", borderColor: "#444" }}>
                            <Accordion.Header>
                                <strong className="text-light">Organization Usage</strong>
                            </Accordion.Header>
                            <Accordion.Body style={{ backgroundColor: "#232323", color: "#fff" }}>
                                <Stack gap={3}>
                                    <div className="d-flex justify-content-between align-items-center py-2 px-2 rounded" style={{ background: "#292929" }}>
                                        <span className="text-light">Users Left</span>
                                        <span className="badge bg-primary">{org?.usersLeft ?? 0}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center py-2 px-2 rounded" style={{ background: "#292929" }}>
                                        <span className="text-light">Agents Left</span>
                                        <span className="badge bg-success">{org?.agentsLeft ?? 0}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center py-2 px-2 rounded" style={{ background: "#292929" }}>
                                        <span className="text-light">Monthly Credits Left</span>
                                        <span className="badge bg-info">{org?.mCreditsLeft ?? 0}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center py-2 px-2 rounded" style={{ background: "#292929" }}>
                                        <span className="text-light">Data Sources Left</span>
                                        <span className="badge bg-warning text-dark">{org?.dataSourcesLeft ?? 0}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center py-2 px-2 rounded" style={{ background: "#292929" }}>
                                        <span className="text-light">Table Rows Left</span>
                                        <span className="badge bg-secondary">{org?.tableRowsLeft ?? 0}</span>
                                    </div>
                                    {/* <div className="d-flex justify-content-between align-items-center py-2 px-2 rounded" style={{ background: "#292929" }}>
                                        <span className="text-light">FAQs Left</span>
                                        <span className="badge bg-danger">{org?.faqsLeft ?? 0}</span>
                                    </div> */}
                                </Stack>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Col>
            </Row>
            
            <Row className="g-4">
                {(!agents || agents.length === 0) ? (
                    <Col xs={12}>
                        <div className="text-center py-5">
                            <div className="bg-secondary rounded-circle p-4 mx-auto mb-3" style={{ width: "80px", height: "80px" }}>
                                <FaRobot className="text-white" size={48} />
                            </div>
                            <h5 className="text-light mb-2">No agents created yet</h5>
                            <p className="text-light">Create your first AI agent to get started.</p>
                            <Button 
                                disabled={!isAllowed || (org && org.agentsLeft <= 0)}
                                variant="primary"
                                onClick={() => setCreateAgent(true)}
                            >
                                <FaPlus className="me-2" />
                                Create First Agent
                            </Button>
                        </div>
                    </Col>
                ) : (
                    agents?.map((agent, idx) => (
                        <Col xs={12} sm={6} md={4} lg={3} key={idx}>
                            <Card 
                                style={{ backgroundColor: "#2d2d2d", borderColor: "#444" }}
                                className="h-100 agent-card-hover"
                            >
                                <Link 
                                    to={`/dashboard/orgs/${agent.organizationId}/${agent.id}`}
                                    className="text-decoration-none"
                                >
                                    <div className="p-4 text-center" style={{ backgroundColor: "#3a3a3a" }}>
                                        <div className="bg-primary rounded-circle p-3 mx-auto mb-2" style={{ width: "60px", height: "60px" }}>
                                            <FaRobot className="text-white" size={24} />
                                        </div>
                                    </div>
                                    <Card.Body className="text-center">
                                        <Card.Title className="text-light mb-2">{agent.name}</Card.Title>
                                        <div className="d-flex justify-content-center align-items-center gap-2">
                                            <small className="text-light">Status:</small>
                                            <small className={agent.isPublished ? "text-success" : "text-warning"}>
                                                {agent.isPublished ? "Published" : "Draft"}
                                            </small>
                                        </div>
                                    </Card.Body>
                                </Link>
                            </Card>
                        </Col>
                    ))
                )}
            </Row>
            </Container>
        </>)
        }
        </div>
    )
}

export default Agents